import { AxiosError, isAxiosError } from 'axios';

import { ZepApiError } from '@zep/apis';
import { logger } from '@zep/core-logger';

export const setApiNetworkLoggerWeb = (error: unknown) => {
  let isNetworkUnstable = false;
  let isNetworkError = false;

  if (isAxiosError(error)) {
    if (!error.response && error.message === 'Network Error') {
      console.warn(
        '네트워크 연결이 불안정하거나 서버에 접근할 수 없습니다.',
        error,
      );
      isNetworkUnstable = true;
    } else if (!error.response) {
      isNetworkUnstable = true;
      console.warn('네트워크 문제 (서버 응답 없음):', error);
    } else if (error.code === 'ECONNABORTED') {
      isNetworkUnstable = true;
      console.warn('요청이 타임아웃되었습니다.', error);
    }

    if (error.response?.status && error.response.status >= 500) {
      isNetworkUnstable = true;
    }

    const status = error.response?.status?.toString() || '';

    if (isNetworkUnstable) {
      logger.captureError(error, {
        level: 'warning',
        fingerprint: ['network-error', getTarget(error), status],
      });
    }
    isNetworkError = true;
  }

  if (error instanceof ZepApiError) {
    isNetworkError = true;
  }

  return isNetworkError;
};

const getTarget = (error: AxiosError) => {
  if (!error.response) {
    return 'client';
  }
  if (error.response?.config.url?.includes('weegloo')) {
    return 'cms';
  }
  if (error.response.config.url?.includes('zep.us')) {
    return 'zep-api';
  }

  return 'unknown';
};
